import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for fetching lesson duties
export const fetchLessonDuties = createAsyncThunk(
  "lessonDuties/fetchLessonDuties",
  async (lessonId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        throw new Error("No authentication token");
      }

      const response = await fetch(`${BASE_URL}/lessons/lesson_duties/${lessonId}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch lesson duties");
      }

      return data;
    } catch (error) {
      console.error('Error fetching lesson duties:', error);
      return rejectWithValue(error.message || "Failed to fetch lesson duties");
    }
  }
);

const initialState = {
  duties: [],
  loading: false,
  error: null,
};

const lessonDutiesSlice = createSlice({
  name: "lessonDuties",
  initialState,
  reducers: {
    clearDutiesError: (state) => {
      state.error = null;
    },
    clearDuties: (state) => {
      state.duties = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLessonDuties.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLessonDuties.fulfilled, (state, action) => {
        state.loading = false;
        // Handle the API response structure with result array
        state.duties = action.payload.result || action.payload;
      })
      .addCase(fetchLessonDuties.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDutiesError, clearDuties } = lessonDutiesSlice.actions;
export default lessonDutiesSlice.reducer; 